<template>
  <v-dialog v-model="showModal" width="700" persistent>
    <v-card>
      <modal-bar :title="barTitle" @onClose="$emit('onCancel')" />

      <div class="px-4 py-7">
        <icon-title
          icon="mdi-cart-remove"
          :text="title"
          class="mb-4"
          title-class="text-subtitle-1 text-md-subtitle-1 black--text ml-4"
        />
        <v-divider color="black" thickness="20px" />
        <div class="form-container mt-7">
          <v-alert v-if="error" outlined color="error" class="mb-4">
            Sucedio un error al elimnar
          </v-alert>

          <v-alert
            v-if="deleted"
            outlined
            color="success"
            class="mb-4 error--text"
          >
            Eliminado correctamente
          </v-alert>

          <v-progress-linear
            v-if="deleting"
            class="mb-4"
            color="#a82222"
            height="20"
            rounded
            indeterminate
          >
            <div class="text-white font-weight-bold">Procesando...</div>
          </v-progress-linear>

          <delete-reasons-form
            v-if="!hideForm"
            v-model="deleteForm"
            :disabled="deleting || deleted"
            :hide-delete="deleted"
            @onCancel="$emit('onCancel')"
            @onDelete="(form) => $emit('deleteOrder', form)"
          />
          <slot name="footer" />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import DeleteReasonsForm from '../forms/DeleteReasonsForm.vue';
  import ModalBar from './ModalBar.vue';
  import IconTitle from '../IconTitle.vue';

  export default {
    name: 'DeleteOrderConfirmationModal',

    components: { ModalBar, IconTitle, DeleteReasonsForm },

    props: {
      value: {
        type: Boolean,
        default: true,
      },

      title: {
        type: String,
        default: '',
      },

      barTitle: {
        type: String,
        default: null,
      },

      hideForm: Boolean,
      deleting: Boolean,
      deleted: Boolean,
      error: Boolean,
    },

    data() {
      return {
        deleteForm: {
          firstReason: '',
        },
      };
    },

    computed: {
      showModal: {
        set(newValue) {
          this.$emit('input', newValue);
        },
        get() {
          return this.value;
        },
      },
    },
  };
</script>

<style>
  .form-container {
    max-width: 400px;
    margin: auto;
  }
</style>
